export default __webpack_public_path__ + "static/media/cp_aws_aws.fc7f70d0.svg";